import { PublicInfoPage } from "@/pages/PublicInfoPage";
import { termsLegalContent } from "@/pages/legalDocuments";

export function TermsPage() {
  return (
    <PublicInfoPage
      canonicalPath="/terms"
      description="Review the terms that govern use of Liminl's matching and introduction service."
      documentTitle="Terms of Service | Liminl"
      headingId="terms-title"
      htmlContent={termsLegalContent}
      navItems={[
        { href: "#acceptance-of-terms", label: "Acceptance of terms" },
        { href: "#description-of-service", label: "Description of service" },
        { href: "#google-sign-in", label: "Google sign-in" },
        { href: "#acceptable-use", label: "Acceptable use" },
        { href: "#ai-content-disclaimer", label: "AI content disclaimer" },
        { href: "#intellectual-property", label: "Intellectual property" },
        { href: "#liability-and-warranties", label: "Liability and warranties" },
        { href: "#terms-contact", label: "Contact" },
      ]}
      pageMeta="Effective 12 August 2026"
      title="Terms of Service"
    />
  );
}
